import * as tslib_1 from "tslib";
var SettingsState_1;
import { State, Action, Store, Selector } from '@ngxs/store';
const category = 'Settings';
export class SetUsageAlerts {
    constructor(alerts) {
        this.alerts = alerts;
    }
}
SetUsageAlerts.type = `[${category}] UsageAlerts`;
export class SetDNASchedules {
    constructor(schedules) {
        this.schedules = schedules;
    }
}
SetDNASchedules.type = `[${category}] SetDNASchedules`;
let SettingsState = SettingsState_1 = class SettingsState {
    constructor(store) {
        this.store = store;
    }
    // available spans state
    static usageAlerts(state) {
        return state.usageAlerts;
    }
    setUsageAlerts(ctx, action) {
        ctx.patchState({
            usageAlerts: action.alerts,
        });
    }
    // selected spans state
    static schedules(state) {
        return state.schedules;
    }
    setDNASchedules(ctx, action) {
        ctx.patchState({
            schedules: action.schedules,
        });
    }
    getUsageAlerts() {
        return this.store.selectSnapshot(SettingsState_1.usageAlerts);
    }
    getDNASchedules() {
        return this.store.selectSnapshot(SettingsState_1.schedules);
    }
};
tslib_1.__decorate([
    Action(SetUsageAlerts),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, SetUsageAlerts]),
    tslib_1.__metadata("design:returntype", void 0)
], SettingsState.prototype, "setUsageAlerts", null);
tslib_1.__decorate([
    Action(SetDNASchedules),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, SetDNASchedules]),
    tslib_1.__metadata("design:returntype", void 0)
], SettingsState.prototype, "setDNASchedules", null);
tslib_1.__decorate([
    Selector([SettingsState_1]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], SettingsState, "usageAlerts", null);
tslib_1.__decorate([
    Selector([SettingsState_1]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], SettingsState, "schedules", null);
SettingsState = SettingsState_1 = tslib_1.__decorate([
    State({
        name: 'settings',
        defaults: {
            usageAlerts: [],
            schedules: [],
        },
    }),
    tslib_1.__metadata("design:paramtypes", [Store])
], SettingsState);
export { SettingsState };
